export default {
    init() {
        $(document).on("click", "[data-group_select]", function (event) {
            event.preventDefault();
            const selectedGroup = $(this);
            const form = selectedGroup.closest("form");
            const group = selectedGroup.data("group_select");

            form.find("[data-category-input]").val("").trigger("change");
            form.find(".category-btn").removeClass("is-visible is-selected").attr("aria-pressed", "false");
            form.find(`.category-btn[data-category="${group}"]`).addClass("is-visible");
            form.find("[data-group_select]").removeClass("is-selected").attr("aria-pressed", "false");
            selectedGroup.addClass("is-selected").attr("aria-pressed", "true");
            form.find("[data-categories_block]").removeClass("is-hidden");
            form.find("[data-expense-wizard]").trigger("expense:group-selected", [selectedGroup.data("choice-label")]);
        });
        $(document).on("click", "[data-category]", function (event) {
            event.preventDefault();
            const selectedCategory = $(this);
            const form = selectedCategory.closest("form");

            form.find("[data-category-input]").val(selectedCategory.data("id")).trigger("change");
            form.find("[data-category]").removeClass("is-selected").attr("aria-pressed", "false");
            selectedCategory.addClass("is-selected").attr("aria-pressed", "true");
            form.find("[data-expense-wizard]").trigger("expense:category-selected", [selectedCategory.data("choice-label")]);
        });
    },
};
